export default {
  title: 'Active Voucher List',
  subtitle: 'Available and valid vouchers',
  searchLabel: 'Search Voucher',
  searchPlaceholder: 'Search by name or voucher code...',
  emptyStateTitle: 'No vouchers available',
  emptyStateSubtitle: 'Vouchers will appear here when available',
  table: {
    courier: 'Courier',
    voucherName: 'Voucher Name',
    voucherCode: 'Voucher Code',
    discount: 'Discount',
    maxDiscount: 'Max. Discount',
    quota: 'Quota',
    period: 'Valid Period',
    action: 'Action'
  },
  allCourier: 'All Couriers',
  periodStart: 'Start:',
  periodEnd: 'End:',
  orderButton: 'Order',
  pagination: {
    previous: 'Previous',
    next: 'Next',
    showing: 'Showing',
    to: '-',
    of: 'of',
    vouchers: 'vouchers'
  }
}
